import React from "react";

const CheckList = ({ title, description, items }) => {
  return (
    <div className="container my-4   ">
      {/* Title */}
      <h2
        className="fw-bold mb-2 title "
        style={{ fontSize: "clamp(1.5rem, 2.5vw, 2rem)" }}
      >
        {title}
      </h2>

      {/* Description */}
      <p className=" mb-3 text-center ">
        {description}
      </p>

      {/* Responsive Checklist */}
      <ul className="list-unstyled row row-cols-1 row-cols-md-2 g-3 g-lg-4">
        {items.map((item, index) => (
          <li key={index} className="col">
            <div className="d-flex align-items-start h-100 p-3 p-sm-3 bg-light rounded-3">
              {/* Icon */}
              <i
                className="fas fa-check-circle mt-1 me-3 flex-shrink-0"
                style={{ fontSize: "1.25rem", color: "#bdaa7d" }}
              ></i>
              {/* Item Text */}
              <span className="fs-8 fs-lg-8">{item.text}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CheckList;
